import React from "react";

import { AssistantToolUseContent } from "@/Chat/ChatSidebar/ChatByIdView/ChatMessage/AssistantToolUseContent.tsx";
import {
  ChatMessage,
  ChatRole,
  isChatTextContent,
  isChatToolUseContent,
  isChatToolResultContent,
  ChatMessageStatus,
} from "@/shared/domain/chat/ChatRecord";

import { AssistantTextContent } from "./AssistantTextContent";
import { AssistantToolResultContent } from "./AssistantToolResultContent";
import styles from "./ChatMessageComponents.module.css";
import { UserMessage } from "./UserMessage";

interface ChatMessageComponentsProps {
  message: ChatMessage;
  isLastMessageInChat: boolean;
  onLinkClick?: () => void;
  autoNavDedupeKey: string;
  autoNavEnabled: boolean;
}

const ChatMessageComponents = ({
  message,
  onLinkClick,
  isLastMessageInChat,
  autoNavDedupeKey,
  autoNavEnabled,
}: ChatMessageComponentsProps) => {
  const components: React.ReactNode[] = [];
  let msgIdx = 0;

  if (message.role === ChatRole.USER) {
    message.content.forEach((content) => {
      if (isChatTextContent(content)) {
        components.push(<UserMessage key={msgIdx++} text={content.text} />);
      }
    });
  }

  if (message.role === ChatRole.ASSISTANT) {
    message.content.forEach((content, idx) => {
      const isLastContentInMessage = idx === message.content.length - 1;
      const isLastContentInChat = isLastContentInMessage && isLastMessageInChat;

      if (isChatTextContent(content)) {
        components.push(
          <AssistantTextContent
            key={msgIdx++}
            text={content.text}
            isGenerating={
              isLastContentInChat &&
              message.status === ChatMessageStatus.GENERATING
            }
            onLinkClick={onLinkClick}
            autoNavDedupeKey={`${autoNavDedupeKey}-${idx}`}
            autoNavEnabled={autoNavEnabled}
          />,
        );
      }

      if (isChatToolUseContent(content)) {
        if (isLastContentInChat) {
          components.push(
            <AssistantToolUseContent key={msgIdx++} toolUse={content} />,
          );
        }
      }
    });
  }

  if (message.role === ChatRole.ROBOTO) {
    message.content.forEach((content) => {
      if (isChatToolResultContent(content)) {
        components.push(
          <AssistantToolResultContent key={msgIdx++} toolResult={content} />,
        );
      }
    });
  }

  if (components.length === 0) {
    return null;
  }

  return <div className={styles.mainContainer}>{components}</div>;
};

export { ChatMessageComponents };
